import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container, Row } from "reactstrap";

import {
  scoringResultsReportEntriesSelector,
  scoringResultsReportPageInfoSelector,
  scoringResultsReportExportCsv,
  scoringResultsIsLoadingSelector,
  scoringResultsReportNoEntriesMessageSelector,
} from "../../selectors";
import {
  getScoringResultsReportEntries,
  getScoringResultsReportEntriesCount,
  setScoringResultsReportEntriesCurrentPage,
  setSearchFilters,
  clearScoringResultsReport,
  setScoringResultsItemsPerPage,
  clearScoringResultsReportCsv,
} from "../../actions";

import ScoringResultsReportForm from "./scoring-results-form";
import ScoringResultsTable from "./scoring-results-table";
import { isEmpty } from "../../../../utilities/typeChecking";
import { notifyWarning } from "../../../../actions";
import { PageTitle } from "../../../../components/common";
import "./scoringResultsReportPage.css";
import Pagination from "../../../../components/Pagination/Pagination";
import FullscreenLoader from "../../../../layouts/FullScreenLoader";
import NoEntriesMessage from "../../../../components/common/NoEntriesMessage/NoEntriesMessage";

const ScoringResultsReportPage = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector(scoringResultsIsLoadingSelector);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isOpenCollapse, setIsOpenCollapse] = useState(true);
  const { count, itemsPerPage, currentPage } = useSelector(
    scoringResultsReportPageInfoSelector
  );
  const noEntriesMessage = useSelector(
    scoringResultsReportNoEntriesMessageSelector
  );
  const scoringResultsReportEntries = useSelector(
    scoringResultsReportEntriesSelector
  );
  const csvFile = useSelector(scoringResultsReportExportCsv);

  const toggleCollapse = () => setIsOpenCollapse(!isOpenCollapse);

  useEffect(() => {
    if (count > 0 && isSubmitted) {
      dispatch(getScoringResultsReportEntries({ take: itemsPerPage }));
      setIsSubmitted(false);
    }
  }, [count]);

  useEffect(
    () => () => {
      dispatch(clearScoringResultsReport());
    },
    []
  );

  useEffect(() => {
    if (!isEmpty(csvFile) && csvFile.fileBytes.size <= 3) {
      dispatch(notifyWarning("There are no records for export yet"));
    } else if (!isEmpty(csvFile) && csvFile.fileBytes.size > 3) {
      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // window.navigator.msSaveOrOpenBlob(url);
        window.navigator.msSaveOrOpenBlob(csvFile.fileBytes, csvFile.fileName);
        return;
      }

      const url = URL.createObjectURL(csvFile.fileBytes);
      const link = document.createElement("a");
      link.href = url;
      link.download = csvFile.fileName;
      link.click();
      setTimeout(() => {
        dispatch(clearScoringResultsReportCsv());

        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(url);
      }, 100);
      // window.location.href(url, '_blank');
    }
    return () => {
      // need to clear the file when it's downloaded :)
      dispatch(clearScoringResultsReportCsv());
    };
  }, [csvFile]);

  const handleSubmit = (data) => {
    if (!isOpenCollapse) {
      return;
    }
    dispatch(setSearchFilters(data));
    dispatch(getScoringResultsReportEntriesCount(data));
    setIsSubmitted(true);
    toggleCollapse();
  };

  const onPageChange = (_, page) => {
    dispatch(setScoringResultsReportEntriesCurrentPage(page + 1));
    const skip = page * itemsPerPage;
    dispatch(getScoringResultsReportEntries({ take: itemsPerPage, skip }));
  };

  const onRowsPerPageChange = ({ target }) => {
    dispatch(setScoringResultsReportEntriesCurrentPage(1));
    dispatch(setScoringResultsItemsPerPage(Number(target.value)));
    dispatch(
      getScoringResultsReportEntries({ take: Number(target.value), skip: 0 })
    );
  };

  return (
    <Container
      className="scoring-results-report-page col-12 p-0"
      tabIndex="0"
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          // TODO: make the id of the submit btn to be like this
          document
            .getElementById("searchScoringResultsEntriesSubmitButton")
            .click();
        }
      }}
    >
      {scoringResultsReportEntries.length ? null : (
        <div className="scoring-results-page-background-logo" />
      )}
      <PageTitle title="scoring results" />
      <FullscreenLoader loading={isLoading} />

      {isOpenCollapse && scoringResultsReportEntries.length ? (
        <div onClick={toggleCollapse} className="overlay-collapse-open" />
      ) : null}
      <ScoringResultsReportForm
        entries={scoringResultsReportEntries}
        isOpenCollapse={isOpenCollapse}
        toggleCollapse={toggleCollapse}
        handleSubmit={handleSubmit}
      />

      <ScoringResultsTable
        scoringResultsReports={scoringResultsReportEntries}
      />

      {count && scoringResultsReportEntries.length ? (
        <Row className="pagination-row mt-5 mb-5">
          <Pagination
            count={count}
            onPageChange={onPageChange}
            onRowsPerPageChange={onRowsPerPageChange}
            rowsPerPage={itemsPerPage}
            page={currentPage - 1}
          />
        </Row>
      ) : (
       <NoEntriesMessage payload={noEntriesMessage} />
      )}
    </Container>
  );
};

ScoringResultsReportPage.propTypes = {};

export default ScoringResultsReportPage;



// WEBPACK FOOTER //
// ./src/features/reports/pages/scoring-results-report-page/ScoringResultsReportPage.jsx